import { render, staticRenderFns } from "./null_events.vue?vue&type=template&id=3d683a72"
import script from "./null_events.vue?vue&type=script&lang=js"
export * from "./null_events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports